// Minimal className combiner — joins truthy class strings. Kept dependency-free
// (the project has no clsx/classnames). Use for conditional Tailwind classes:
//   cn('p-2', isActive && 'bg-brand', disabled && 'opacity-50')
export type ClassValue = string | number | false | null | undefined;

export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(' ');
}
